// md5 加密
import { md5 } from "@plugins";

// 字符串加密
const passwordMd5 = (password) => {
  return md5(md5(password).split("").reverse().join(""));
};

// 导出
export { passwordMd5 };
